import { createSelector } from 'reselect';

import { GlobalStore, key } from './store';

const selectStore = (state: GlobalStore) => state[key];

export const makeSelectObject = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'object'])
	);

export const makeSelectObjectId = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'objectId'])
	);

export const makeSelectInProgress = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'inProgress'])
	);

export const makeSelectFieldsErrors = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'fieldsErrors'])
	);

export const makeSelectFieldsSucceeded = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'fieldsSucceeded'])
	);

export const makeSelectRequestParams = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'requestParams']) || []
	);

export const makeSelectFilters = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'filters']) || []
	);

export const makeSelectError = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'error'])
	);
